export const environment = {
    production: true,
    APP_HOST: 'https://node-codeflix-invoice.codeflix.org/api',
    BASE_URL: 'https://node-codeflix-invoice.codeflix.org/uploads',
    API_URL: 'https://node-codeflix-invoice.codeflix.org',
    // APP_HOST: 'http://localhost:5000/api',
    // BASE_URL: 'http://localhost:5000/uploads',
    // API_URL: 'http://localhost:5000'
};
    